// NGRX
import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import { storeFreeze } from 'ngrx-store-freeze';
import { routerReducer, RouterReducerState } from '@ngrx/router-store';
import { environment } from 'src/environments/environment';
import { gamePlanReducer, gamePlanState, studentJourneyState, studentJourneyReducer } from 'src/app/_store/reducers/gameplan.reducer';



// tslint:disable-next-line:no-empty-interface
export interface AppState {
    router: RouterReducerState;
    gamePlanActiveState: gamePlanState;
    studentJourneyState:studentJourneyState

}

export const reducers: ActionReducerMap<AppState> = { router: routerReducer, gamePlanActiveState: gamePlanReducer, studentJourneyState:studentJourneyReducer  };

export const metaReducers: MetaReducer<AppState>[] = !environment.production ? [storeFreeze] : [];
